/**
 * Normalize feed row `details` for inspect modals (scalars, arrays, nested objects).
 */

/**
 * @param {string} key
 * @returns {string}
 */
export function formatDetailLabel(key) {
  return String(key || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}

/**
 * @param {unknown} value
 * @returns {string}
 */
export function formatDetailScalar(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  const text = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}T/.test(text)) {
    try {
      return new Date(text).toLocaleString();
    } catch {
      return text;
    }
  }
  return text;
}

const HIDDEN_DETAIL_KEYS = new Set([
  'infra_inspect',
  'subdomains',
  'asn_records',
  'inspect_url',
  'photo_url',
  'avatar_url',
]);

/**
 * @param {Record<string, unknown>} details
 * @returns {Array<{ key: string, label: string, value: unknown, kind: 'scalar' | 'array' | 'object' }>}
 */
export function collectDetailEntries(details) {
  if (!details || typeof details !== 'object' || Array.isArray(details)) return [];

  return Object.entries(details)
    .filter(([key, value]) => {
      if (HIDDEN_DETAIL_KEYS.has(key)) return false;
      if (value == null || value === '') return false;
      if (Array.isArray(value) && value.length === 0) return false;
      if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
        return false;
      }
      return true;
    })
    .map(([key, value]) => ({
      key,
      label: formatDetailLabel(key),
      value,
      kind: Array.isArray(value) ? 'array' : typeof value === 'object' ? 'object' : 'scalar',
    }));
}
